import type { OnInit } from '@angular/core';
import { Component, Input } from '@angular/core';
import type { IAccordion } from '@legacy/common-ui-utility-components';
import { componentViewModelSelector } from '@core/experience-editor-utils';
import { getLinkFieldValue } from '@core/jss-utils';
import { Store } from '@ngrx/store';
import type { SolarPanelsProductWithCalculations } from '@innogy/feh/models';
import {
  selectSolarPanelsResultOverviewViewModal,
  solarPanelsResultOverviewHideLoaderAction,
  solarPanelsResultOverviewShowLoaderAction,
  solarPanelsResultOverviewSubmitAction,
} from '@feh/solar-panels-store';

import { SolarPanelsResultOverviewRendering } from '../../models/solar-panels-result-overview-rendering.interface';
import { initializeSolarPanelsFunnelComponent } from '../../utils/initialize-solar-panels-funnel-component';
import { mockSolarPanelsResultOverviewViewModel } from './solar-panels-result-overview-container.component.xp.mock';

@Component({
  selector: 'wl-solar-panels-result-overview-container[rendering]',
  templateUrl: './solar-panels-result-overview-container.component.html',
  styleUrls: [
    'solar-panels-result-overview-container.component.essent.scss',
    'solar-panels-result-overview-container.component.ed.scss',
  ],
})
export class SolarPanelsResultOverviewContainerComponent implements OnInit {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rendering!: SolarPanelsResultOverviewRendering;

  accordion?: IAccordion;

  loaderDuration = 3000;

  readonly viewModel$ = this.store$.select(
    componentViewModelSelector(
      selectSolarPanelsResultOverviewViewModal,
      mockSolarPanelsResultOverviewViewModel
    )
  );

  constructor(private readonly store$: Store) {}

  ngOnInit() {
    this.store$.dispatch(
      initializeSolarPanelsFunnelComponent(
        'resultOverview',
        this.rendering?.fields.FunnelSettings
      )
    );
    this.setAccordion();
    if (this.fields.LoaderEnabled?.value) {
      this.showLoader();
    }
  }

  setAccordion() {
    const buttonText = this.rendering.fields.MoreInfoButtonText?.value;
    const descriptionText =
      this.rendering.fields.MoreInfoDescriptionText?.value;

    if (buttonText && descriptionText) {
      this.accordion = {
        items: [
          {
            id: 'more-info',
            question: {
              value: buttonText,
            },
            answer: {
              value: descriptionText,
            },
          },
        ],
      };
    }
  }

  showLoader() {
    this.store$.dispatch(solarPanelsResultOverviewShowLoaderAction());
  }

  hideLoader() {
    this.store$.dispatch(solarPanelsResultOverviewHideLoaderAction());
  }

  get fields() {
    return this.rendering.fields;
  }

  onClickSubmitButton(product?: SolarPanelsProductWithCalculations) {
    if (!product) {
      throw new Error(
        'Attempted to submit solar overview without providing a product.'
      );
    }
    this.store$.dispatch(solarPanelsResultOverviewSubmitAction({ product }));
  }

  get secondaryButtonLinkValue() {
    return getLinkFieldValue(this.fields, 'SecondaryButtonLink');
  }
}
